module.exports = __webpack_public_path__ + "static/img/casino-top-bg-MO.fb0d46e.jpg";